import { render, staticRenderFns } from "./LearnMorePages.vue?vue&type=template&id=649af430&scoped=true"
import script from "./LearnMorePages.vue?vue&type=script&lang=ts"
export * from "./LearnMorePages.vue?vue&type=script&lang=ts"
import style0 from "./LearnMorePages.vue?vue&type=style&index=0&id=649af430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649af430",
  null
  
)

export default component.exports